// extracted by mini-css-extract-plugin
module.exports = {"warning":"MessageSentContent_warning__2wqag"};